import { i18n } from '../i18nType';

export const VIEW_BATCH_LABEL: i18n = { en: 'View Batch' };
export const VIEW_BATCHES_LABEL: i18n = { en: 'View Batches' };
export const ADD_BATCH_LABEL: i18n = { en: 'Add Batch' };
export const NAME = { en: 'Name' };
export const TYPE = { en: 'Type' };
export const NO_OF_BATCHES = { en: 'No of Batches' };
export const SUBSTANCE_ACTIONS = { en: 'Substance Actions' };
